import React from 'react';
import { Card } from 'primereact/card';
import { BusinessTypeValue } from './types'; // Importáljuk a típust

interface BusinessTypeSelectionProps {
  businessType: BusinessTypeValue; // Kiválasztott business típus
  setBusinessType: React.Dispatch<React.SetStateAction<BusinessTypeValue>>; // Állapot frissítése
}

const BusinessTypeSelection: React.FC<BusinessTypeSelectionProps> = ({ businessType, setBusinessType }) => {
  const businessTypes = [
    { label: 'Single Location', value: 'single' },
    { label: 'Multiple Locations', value: 'multiple' },
    { label: 'Franchise', value: 'franchise' },
  ];

  const handleSelect = (type: BusinessTypeValue) => {
    setBusinessType(type); // Állapot frissítése a kiválasztott típussal
  };

  return (
    <div className="onboarding-container">
      <div className="card-selection-container">
        {businessTypes.map((type) => (
          <Card
            key={type.value}
            title={type.label}
            className={`business-card ${businessType === type.value ? 'selected' : ''}`}
            onClick={() => handleSelect(type.value as BusinessTypeValue)}
          >
            <p>Leírás a {type.label}-ról.</p>
          </Card>
        ))}
      </div>
    </div>
  );
};

export default BusinessTypeSelection;
